export { default as SimpleMasthead } from './simpleMasthead';
export { simpleMastheadType } from './simpleMasthead.types';
export { simpleMastheadFragment } from './simpleMasthead.fragment';
